module.exports = __webpack_public_path__ + "static/media/video-black.6c8e359c.svg";